import { LinkLabel, Pressed } from 'libs/ui';

import { DocumentItemType } from '../types';

export const renderName = (
  item: DocumentItemType,
  onClickName?: (item: DocumentItemType) => void
) => (
  <Pressed className="ellipsisText">
    <LinkLabel
      className="ellipsisText"
      datax="document-name"
      label={item.name}
      title={item.name}
      typographyVariant="caption"
      onClick={() => onClickName?.(item)}
    />
  </Pressed>
);
